// Import this in child components to use alerts.
import { createAlertsManager } from '@bigcommerce/big-design';

export const alertsManager = createAlertsManager();
